export default __webpack_public_path__ + "static/media/05-advanced-infusion-services.2a3bad13.png";